// 籌碼結算圖片數字的純水平排版規則。
//
// === 使用圖片 ===
// 無 — 只計算各字元位置，不直接渲染畫面。

export interface IResultMoneyGlyphMetrics {
  readonly digitAdvance: number;
  readonly commaAdvance: number;
  readonly commaLeadingGap: number;
  readonly minusAdvance: number;
}

export interface IResultMoneyGlyphPlacement {
  readonly character: string;
  readonly x: number;
}

export interface IResultMoneyGlyphLayout {
  readonly glyphs: readonly IResultMoneyGlyphPlacement[];
  readonly width: number;
}

/** 千分位逗號先留出前距，再使用自己的完整字格寬度，避免壓住前後數字。 */
export function buildResultMoneyGlyphLayout(
  text: string,
  metrics: IResultMoneyGlyphMetrics
): IResultMoneyGlyphLayout {
  const glyphs: IResultMoneyGlyphPlacement[] = [];
  let cursorX = 0;

  for (const character of text) {
    const isComma = character === ',';
    const isMinus = character === '-';
    if (isComma) cursorX += metrics.commaLeadingGap;
    glyphs.push({ character, x: cursorX });
    cursorX += isComma
      ? metrics.commaAdvance
      : isMinus
        ? metrics.minusAdvance
        : metrics.digitAdvance;
  }

  return { glyphs, width: cursorX };
}

/** 永久籌碼允許為負數；只取整數並保留負號，再插入千分位。 */
export const formatResultChip = (value: number): string =>
  Math.floor(value)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
